<template>
  <v-navigation-drawer v-model="drawer" :mini-variant="mini" permanent app>
    <v-list dense>
      <v-list-item link @click.stop="mini = !mini">
        <v-list-item-icon>
          <v-icon v-if="mini">mdi-menu</v-icon>
          <v-icon v-else>mdi-chevron-left</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>メニュー</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-divider />

      <div v-for="(item, itemIndex) in items" :key="itemIndex">
        <div v-for="si in item.subitems" :key="si.key">
          <v-list-item
            v-if="si.hide !== true"
            link
            @click="si.onclick"
            :input-value="selectedRisk.title === si.title"
          >
            <template v-if="si.hide !== true">
              <v-list-item-icon>
                <v-tooltip right z-index="3000">
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon v-bind="attrs" v-on="on">{{ si.icon }}</v-icon>
                  </template>
                  <span>{{ si.title }}</span>
                </v-tooltip>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>{{ si.title }}</v-list-item-title>
              </v-list-item-content>
            </template>
          </v-list-item>
        </div>
        <v-divider />
      </div>
      <v-list-item link to="/login" v-if="isPrivateMode">
        <v-list-item-icon>
          <v-icon>mdi-exit-to-app</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>ログアウト</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
    <GlossaryDialog :dialog="glossaryDialog" @close="glossaryDialog = false" />
    <NotesDialog :dialog="notesDialog" @close="notesDialog = false" />
    <CsvDownload :dialog="csvDialog" @close="csvDialog = false" />
  </v-navigation-drawer>
</template>

<script>
import { Risk } from "../enums/Risk";
import { BRANCH_OFFICE } from "../enums/BranchOffice";
import { isPrivateMode, isPublicMode } from "../utils/common";
import GlossaryDialog from "./GlossaryDialog";
import NotesDialog from "./NotesDialog";
import CsvDownload from "./CsvDownload";

export default {
  name: "NavigationDrawer",
  components: {
    GlossaryDialog,
    NotesDialog,
    CsvDownload
  },
  data() {
    return {
      isPrivateMode,
      drawer: true,
      mini: true,
      glossaryDialog: false,
      notesDialog: false,
      csvDialog: false,
      items: []
    };
  },
  computed: {
    selectedRisk() {
      return this.$store.getters.selectedRisk;
    },
    map() {
      return this.$store.getters.leafletMap;
    },
    isAdmin() {
      return this.$store.state.user.profile === "admin";
    }
  },
  methods: {
    //
  },
  created() {
    this.items = [
      {
        subitems: [
          {
            key: "home",
            icon: "mdi-home-map-marker",
            title: "ホーム",
            onclick: () => {
              this.$store.commit("SET_IS_CAMERA_MONITOR", false);
              this.$store.commit("SET_MAP_DETAIL", { isShowing: false });
              this.$store.commit("SET_IS_RIGHT_NAV", true);
              this.$store.commit("SET_IS_MONITORING", true);
              if (this.map) {
                this.map.panTo([BRANCH_OFFICE[0].lat, BRANCH_OFFICE[0].lng]);
                setTimeout(() => {
                  this.map.setZoom(13);
                }, 800);
              }
            }
          },
          {
            key: Risk.RAIN.key,
            icon: Risk.RAIN.icon,
            title: Risk.RAIN.title,
            onclick: () => this.$store.commit("SET_SELECTED_RISK", Risk.RAIN)
          },
          {
            key: Risk.RIVER_FLOODING.key,
            icon: Risk.RIVER_FLOODING.icon,
            title: Risk.RIVER_FLOODING.title,
            onclick: () =>
              this.$store.commit("SET_SELECTED_RISK", Risk.RIVER_FLOODING)
          },
          {
            key: Risk.DOSYA.key,
            icon: Risk.DOSYA.icon,
            title: Risk.DOSYA.title,
            onclick: () => this.$store.commit("SET_SELECTED_RISK", Risk.DOSYA)
          },
          {
            key: Risk.KOUZUI.key,
            icon: Risk.KOUZUI.icon,
            title: Risk.KOUZUI.title,
            onclick: () => this.$store.commit("SET_SELECTED_RISK", Risk.KOUZUI)
          }
        ]
      },
      {
        subitems: [
          {
            icon: Risk.TYPHOON.icon,
            title: Risk.TYPHOON.title,
            onclick: () => window.open(Risk.TYPHOON.url)
          },
          {
            icon: Risk.DISASTER_PREVENTION.icon,
            title: Risk.DISASTER_PREVENTION.title,
            onclick: () => window.open(Risk.DISASTER_PREVENTION.url)
          }
        ]
      },
      {
        subitems: [
          {
            icon: "mdi-download-circle",
            title: "CSVダウンロード",
            onclick: () => {
              this.csvDialog = true;
            },
            hide: isPublicMode
          },
          {
            icon: "mdi-monitor-eye",
            title: "水位・雨量モニタ",
            onclick: () => {
              const bool = !this.$store.getters.isMonitoring;
              this.$store.commit("SET_IS_MONITORING", bool);
              if (bool === true) {
                this.$store.commit("SET_IS_CAMERA_MONITOR", false);
                this.$store.commit("SET_IS_MANHOLE_MONITOR", false);
              }
            }
          },
          {
            icon: "mdi-alpha-m-circle",
            title: "マンホール・水路モニタ",
            onclick: () => {
              const bool = !this.$store.getters.isManholeMonitor;
              this.$store.commit("SET_IS_MANHOLE_MONITOR", bool);
              if (bool === true) {
                this.$store.commit("SET_IS_CAMERA_MONITOR", false);
                this.$store.commit("SET_IS_MONITORING", false);
                this.$store.commit("SET_MAP_DETAIL", { isShowing: false });
              }
            },
            hide: isPublicMode
          },
          {
            icon: "mdi-monitor-dashboard",
            title: "カメラ一覧",
            onclick: () => {
              const bool = !this.$store.getters.isCameraMonitor;
              this.$store.commit("SET_IS_CAMERA_MONITOR", bool);
              this.$store.commit("SET_IS_MANHOLE_MONITOR", !bool);
              this.$store.commit("SET_IS_MONITORING", !bool);
              this.$store.commit("SET_IS_RIGHT_NAV", !bool);
              this.$store.commit("SET_MAP_DETAIL", { isShowing: false });
            }
          },
          {
            icon: "mdi-message-bulleted",
            title: "お知らせ",
            onclick: () => {
              if (this.$store.getters.isShowMapDetail === true) {
                this.$store.commit("SET_MAP_DETAIL", { isShowing: false });
                this.$store.commit("SET_IS_RIGHT_NAV", true);
              } else {
                const bool = !this.$store.getters.isRightNavVisible;
                this.$store.commit("SET_IS_RIGHT_NAV", bool);
                if (bool === true) {
                  this.$store.commit("SET_IS_CAMERA_MONITOR", false);
                }
              }
            }
          }
        ]
      },
      {
        subitems: [
          {
            icon: "mdi-shield-account",
            title: "管理者機能",
            hide: isPublicMode || this.isAdmin !== true,
            onclick: () => {
              window.open("/#/admin", "_blank");
            }
          },
          {
            icon: "mdi-book-open-variant-outline",
            title: "用語の説明",
            onclick: () => {
              this.glossaryDialog = true;
            }
          },
          {
            icon: "mdi-book-open-variant",
            title: "ご利用マニュアル",
            onclick: () => {
              window.open(
                "https://s3.ap-northeast-1.amazonaws.com/ctie.kashiwa.web/manual.pdf",
                "_blank"
              );
            }
          },
          {
            icon: "mdi-alert-outline",
            title: "ご利用に際して",
            onclick: () => {
              this.notesDialog = true;
            }
          }
        ]
      }
    ];
  }
};
</script>
